import React from 'react';

import { styled } from '@mui/material/styles';
import { Color } from '../../theme';
import { Card } from '../components/Card';
import ConcreteMixerIcon from '../components/ConcreteMixerIcon';
import Icon from '../components/Icon';

import {
  faHandSparkles,
  faMound
} from '@fortawesome/free-solid-svg-icons';

type Props = {
  className?: string;
};

const Container = styled('section')`
  .cards {
    display: flex;
    gap: ${(p) => p.theme.spacing(3)};
    margin-top: ${(p) => p.theme.spacing(5)};

    .media {
      height: 72px;
    }
  }

  .long-copy {
    margin-bottom: ${(p) => p.theme.spacing(7)};
  }
`;

const StyledIcon = styled(Icon)`
  color: ${Color.green};
  display: block;
  font-size: 3rem;
  margin-bottom: 10px;
`;

const Products = ({ className }: Props) => (
  <Container className={className} id='products'>
    <div className='row'>
      <h2>Products</h2>
      <p className='long-copy'>
        At Coastal Cement, we're more than just a cement supplier — we're a family.
        As a locally owned and operated business, our mission goes beyond supplying
        cement; it's about building stronger communities, one project at a time.
      </p>
      <div className='cards'>
        <Card
          media={<StyledIcon icon={faMound} />}
          header={<h3>Portland Cement</h3>}
          content={
            <p>
              Type I/II Low Alkali - our specialty.
              <br /><br />
              This versatile product is designed to meet a wide range of construction needs,
              ensuring durability and strength for everything from residential buildings to commercial
              infrastructure.
              <br /><br />
              Our commitment to quality means we carefully select our cement, ensuring it
              meets the rigorous standards our customers expect and require.
            </p>
          }
        />
        <Card
          media={<ConcreteMixerIcon />}
          header={<h3>Experience</h3>}
          content={
            <p>
              As end users ourselves, we understand the critical importance of cement quality and
              availability.
              <br /><br />
              Our firsthand experience in ready mix and block production has deeply
              ingrained in us the values of precision, durability, and performance. It's this unique
              perspective that sets us apart and drives us to maintain the highest standards in everything
              we do.
            </p>
          }
        />
        <Card
          media={<StyledIcon icon={faHandSparkles} />}
          header={<h3>Tailored Solutions</h3>}
          content={
            <p>
              Understanding that each project has its own set of challenges and requirements, we offer the
              flexibility to accommodate specialty needs.

              <br /><br />
              With enough advanced notice, we can work closely
              with you to source and supply cement that meets specific criteria, ensuring your project's
              success without compromise.
            </p>
          }
        />
      </div>
    </div>
  </Container>
);

export default Products;

